module.exports = __webpack_public_path__ + "img/34.b232a7e8.png";